import { useState } from "react";
import { createContext } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import { getPaymentsUserService } from "./../../../services/userServices";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";

export const paymentUserContext = createContext({
  payments: [],
  setPayments: () => {},
  payment: {},
  setPayment: () => {},
  filter: "",
  setFilter: () => {},
  sort: "",
  setSort: () => {},
  start: "",
  setStart: () => {},
  end: "",
  setEnd: () => {},
  status: "",
  setStatus: () => {},
  gateway: "",
  setGateway: () => {},
  pageCount: null,
  setPageCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  itemsCount: null,
  setItemsCount: () => {},
  handleGetPayments: () => {},
});

const PaymentUserContext = ({ children }) => {
  const dispatch = useDispatch();

  const { user, invoice } = useParams();

  const [payments, setPayments] = useState([]);
  const [payment, setPayment] = useState({});
  const [filter, setFilter] = useState("");
  const [sort, setSort] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [status, setStatus] = useState("");
  const [gateway, setGateway] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsCount, setItemsCount] = useState(100);

  // Get Payments
  const handleGetPayments = async (event) => {
    event?.preventDefault();

    const objData = {
      ...(start && { start }),
      ...(end && { end }),
      ...(user && { user }),
      ...(invoice && { invoice }),
      filter,
      pageNumber,
      sort,
      itemsCount,
      status,
      gateway,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getPaymentsUserService(objData);
      if (status === 200) {
        setPayments(data.result?.payments);
        setPageCount(data?.result?.allPagesCount);
      }
    } catch ({ response }) {
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <paymentUserContext.Provider
      value={{
        payments,
        setPayments,
        payment,
        setPayment,
        filter,
        setFilter,
        sort,
        setSort,
        start,
        setStart,
        end,
        setEnd,
        status,
        setStatus,
        gateway,
        setGateway,
        pageCount,
        setPageCount,
        pageNumber,
        setPageNumber,
        itemsCount,
        setItemsCount,
        handleGetPayments,
      }}
    >
      {children}
    </paymentUserContext.Provider>
  );
};

export default PaymentUserContext;
